import { useBaseAPI } from 'apiServices/baseAPI';

export function useAccessHistoryAPI({ patientID }) {
  return useBaseAPI({
    method: 'GET',
    route: `consentimento/recurso/${patientID}/autorizacao?resultado=Autorizado`,
    additionalHeaders: {
      Accept: '*/*',
    },
  });
}
